import type { AgentOffice } from 'types/agents';

export function OfficeSelect({
  value,
  onChange,
}: {
  value: AgentOffice;
  onChange: (value: AgentOffice) => void;
}) {
  return (
    <div>
      <label className="mb-1 block text-sm font-medium text-gray-700">Kontor</label>
      <div className="inline-flex overflow-hidden rounded-lg border border-gray-200">
        {(['front', 'back'] as AgentOffice[]).map((office) => (
          <button
            key={office}
            type="button"
            onClick={() => onChange(office)}
            className={`px-3 py-1.5 text-sm transition ${
              value === office ? 'bg-blue-50 text-blue-700' : 'text-gray-500 hover:bg-gray-50'
            }`}
          >
            {office === 'front' ? 'Front' : 'Back'}
          </button>
        ))}
      </div>
    </div>
  );
}

export function MaxChatsStepper({
  value,
  onChange,
}: {
  value: number;
  onChange: (value: number) => void;
}) {
  return (
    <div>
      <label className="mb-1 block text-sm font-medium text-gray-700">Max chattar</label>
      <div className="inline-flex items-center overflow-hidden rounded-lg border border-gray-200">
        <button
          type="button"
          aria-label="Minska"
          onClick={() => onChange(Math.max(0, value - 1))}
          className="px-3 py-1.5 text-gray-600 hover:bg-gray-50"
        >
          −
        </button>
        <span className="px-4 text-sm font-medium">{value}</span>
        <button
          type="button"
          aria-label="Öka"
          onClick={() => onChange(value + 1)}
          className="px-3 py-1.5 text-gray-600 hover:bg-gray-50"
        >
          +
        </button>
      </div>
    </div>
  );
}
